import signupFormSubmitted from "../events/signup-form-submitted.js";
function makeEventRouter() {
    const router = {
        'signup-form-submitted': signupFormSubmitted
    };
    return Object.freeze({
        get
    });
    function get(action) {
        return router[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
